module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav",
    class: {
      'nav-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    class: {
      'hide': _vm.isOpenedInIFrame
    },
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": "/static/app-logo.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "app-logo-name"
  }, [_vm._v("Crypto"), _c('span', [_vm._v("Dash")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('span', {
    staticClass: "nav-item"
  }, [_c('img', {
    staticClass: "iframe-app-logo",
    class: {
      'show': _vm.isOpenedInIFrame
    },
    attrs: {
      "src": "/static/app-logo.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-success is-inverted is-outlined",
    class: {
      'hide': _vm.isOpenedInIFrame
    },
    on: {
      "click": _vm.toggleModal
    }
  }, [_c('span', [_vm._v("What's this?")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.modalActive
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.toggleModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "footer-title"
  }, [_vm._v("Peppersalts Studio | "), _c('icon', {
    attrs: {
      "name": "calendar",
      "height": "12"
    }
  }), _vm._v(" 2018")], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-social-media"
  }, [_c('a', {
    staticClass: "icon",
    attrs: {
      "href": "https://github.com/viralpatel380",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "github-square",
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "href": "https://www.linkedin.com/in/viralpatel3654/",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "href": "mailto:s.viralbp@itmvu.in",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope-square",
      "scale": "2"
    }
  })], 1)])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-medium",
    on: {
      "click": _vm.toggleModal
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v(" CryptoDash ")]), _vm._v(" "), _c('img', {
    staticClass: "modal-body-logo",
    attrs: {
      "src": "/static/app-logo.png",
      "id": "app-logo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Cryptocurrencies emerged in 2009 with the first decentralized cryptocurrency - "), _c('a', {
    attrs: {
      "href": "https://bitcoin.org/en/",
      "target": "_blank"
    }
  }, [_vm._v("Bitcoin")]), _vm._v(". As of today - more than 700 digital currencies exist with a total market capitalization greater than 100 billion USD. ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank"
    }
  }, [_vm._v("CryptoDash")]), _vm._v(" is a real-time dashboard that displays the top 10 cryptocurrencies based on currency price, market capitalization and overall circulating supply - obtained from the leading cryptocurrency resource "), _c('a', {
    attrs: {
      "href": "https://coinmarketcap.com/",
      "target": "_blank"
    }
  }, [_vm._v("CoinMarketCap")]), _vm._v(".")]), _vm._v(" "), _c('h3', [_vm._v("Vue")]), _vm._v(" "), _c('img', {
    staticClass: "modal-body-logo",
    attrs: {
      "src": "/static/vue_logo.png",
      "id": "vue-logo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Built as a weekend project, this was a great introduction in  understanding the common concepts of "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("Vue")]), _vm._v(" (reusable single-file components, vue-router, templating, etc.). ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v("Styling of the application was done with "), _c('a', {
    attrs: {
      "href": "http://bulma.io/",
      "target": "_blank"
    }
  }, [_vm._v("Bulma")]), _vm._v(" (Flexbox based CSS framework) and SASS. Head over to the my "), _c('a', {
    attrs: {
      "href": "https://github.com/viralpatel380/crypto_dash",
      "target": "_blank"
    }
  }, [_vm._v("github page")]), _vm._v(" to see the entire scaffold and feel free to reach out with any comments/questions!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24af0f0f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderHero.vue
// module id = 1071
// module chunks = 1